import { Routes } from '@angular/router';
import { MapSetupComponent } from './setup/form/map_setup.component';
import { WizardComponent } from '../containers/main/wizard/wizard.component';
import { MapPreviewComponent } from './setup/preview/map_preview.component';
import { SetupStepNavComponent } from '../shared/navigation/setup_step/setup_step_nav.component';

export const mapRoutes: Routes = [

    {path: '', component: MapPreviewComponent, outlet: 'side'},
    {path: '', component: WizardComponent, outlet: 'main', children : [
      { path: '',
        component: MapSetupComponent,
        outlet: 'stepContent'
      },
      { path: '',
        component: SetupStepNavComponent,
        outlet: 'stepNavigation'
      }
    ]}
];
